/**
 * Berndorf — Nachkauf-Accordion und Quickview.
 *
 * Die eine Mechanik, die das Design von einem Standard-PDP unterscheidet:
 * ein Klick legt **mehrere verschiedene Produkte** mit je eigener Menge in den
 * Warenkorb (Screen 8). Der Quickview (Screen 9) hängt daran, weil er dieselben
 * Zeilendaten benutzt.
 *
 * Warum nicht Dawns <product-form>: das kennt genau eine Variante je Absenden.
 * /cart/add akzeptiert aber ein `items`-Array — genau das braucht die Zeile.
 *
 * Die Warenkorb-Anzeige im Header wird über die Sections-API neu gerendert,
 * statt die Zahl im DOM hochzuzählen. Sonst driftet sie, sobald an anderer
 * Stelle etwas am Warenkorb passiert.
 */
(function () {
  'use strict';

  var strings = readStrings();

  function readStrings() {
    var node = document.querySelector('[data-berndorf-product-strings]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return {};
    }
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  /* ------------------------------------------------------------ Warenkorb */

  function addItems(items) {
    return fetch(addUrl() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'cart error');
        }
        return data;
      });
    });
  }

  /**
   * Holt die Header-Section frisch und tauscht die Warenkorb-Anzeige aus.
   * Fehler hier dürfen den Kauf nicht stören — der Artikel liegt bereits im
   * Warenkorb, die Zahl im Header ist Kosmetik.
   */
  function refreshCartCount() {
    var current = document.getElementById('cart-icon-bubble');
    if (!current) return Promise.resolve();

    return fetch(window.location.pathname + '?section_id=header')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('cart-icon-bubble');
        if (fresh) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        /* bewusst still */
      });
  }

  function announce(target, message, isError) {
    if (!target) return;
    target.textContent = message || '';
    target.classList.toggle('is-error', isError === true);
  }

  /**
   * Der Plural-String trägt den Zähler als literales `__COUNT__`, nicht als
   * Liquid-Platzhalter. Damit die Zahl erst hier entsteht — Shopifys
   * Pluralisierung greift beim Rendern, kennt die Menge aber noch nicht.
   */
  function successMessage(count) {
    if (count === 1 && strings.success_one) return strings.success_one;
    if (!strings.success_other) return '';
    return strings.success_other.replace('__COUNT__', count);
  }

  /* --------------------------------------------------- Mehrfach-Hinzufügen */

  function collectItems(form) {
    var items = [];

    form.querySelectorAll('[data-berndorf-nachkauf-row]').forEach(function (row) {
      var input = row.querySelector('[data-berndorf-stepper-input]');
      var idField = row.querySelector('input[name$="[id]"]');
      if (!input || !idField) return;

      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 1) return;

      items.push({ id: parseInt(idField.value, 10), quantity: quantity });
    });

    return items;
  }

  function resetForm(form) {
    form.querySelectorAll('[data-berndorf-nachkauf-row] [data-berndorf-stepper-input]').forEach(function (input) {
      input.value = 0;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-berndorf-nachkauf-form]');
    if (!form) return;

    event.preventDefault();

    var feedback = form.querySelector('[data-berndorf-nachkauf-feedback]');
    var submit = form.querySelector('[data-berndorf-nachkauf-submit]');
    var items = collectItems(form);

    if (!items.length) {
      announce(feedback, strings.empty, true);
      return;
    }

    submit.disabled = true;
    submit.classList.add('is-loading');
    announce(feedback, '');

    addItems(items)
      .then(function () {
        var total = items.reduce(function (sum, item) {
          return sum + item.quantity;
        }, 0);
        resetForm(form);
        announce(feedback, successMessage(total));
        return refreshCartCount();
      })
      .catch(function (error) {
        announce(feedback, error.message || strings.error, true);
      })
      .then(function () {
        submit.disabled = false;
        submit.classList.remove('is-loading');
      });
  });

  /* ------------------------------------------------- Auf- und Zuklappen
     <details> klappt von Haus aus in einem Frame. Die Höhe wird deshalb von
     der Summary-Höhe auf die volle Höhe animiert (und zurück); `open` fällt
     beim Schliessen erst nach der Animation weg, sonst wäre der Inhalt schon
     weg. Ohne JS oder bei reduzierter Bewegung klappt es wie bisher. */

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function token(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.berndorf-nachkauf__summary');
    if (!summary || reduceMotion.matches) return;

    var details = summary.parentElement;
    event.preventDefault();

    var from = details.offsetHeight;
    var closing = details.open && !details.classList.contains('is-closing');
    if (details._berndorfAnimation) details._berndorfAnimation.cancel();

    details.classList.toggle('is-closing', closing);
    details.open = true;
    /* scrollHeight und die Summary zählen den Rahmen nicht mit. */
    var border = details.offsetHeight - details.clientHeight;
    var to = (closing ? summary.offsetHeight : details.scrollHeight) + border;

    var animation = details.animate(
      { height: [from + 'px', to + 'px'] },
      {
        duration: parseFloat(token(closing ? '--berndorf-duration-base' : '--berndorf-duration-slow')) || 0,
        easing: token(closing ? '--berndorf-easing-accelerate' : '--berndorf-easing-decelerate') || 'ease'
      }
    );
    details._berndorfAnimation = animation;

    animation.onfinish = function () {
      details._berndorfAnimation = null;
      details.classList.remove('is-closing');
      if (closing) details.open = false;
    };
  });

  /* -------------------------------------------------------------- Quickview */

  var quickview = {
    root: null,
    dialog: null,
    slot: null,
    opener: null
  };

  function ensureQuickview() {
    if (quickview.root) return quickview.root;

    quickview.root = document.querySelector('[data-berndorf-quickview]');
    if (!quickview.root) return null;

    quickview.dialog = quickview.root.querySelector('.berndorf-quickview__dialog');
    quickview.slot = quickview.root.querySelector('[data-berndorf-quickview-slot]');
    return quickview.root;
  }

  function openQuickview(button) {
    var root = ensureQuickview();
    if (!root) return;

    var row = button.closest('[data-berndorf-nachkauf-row]');
    var template = row && row.querySelector('[data-berndorf-quickview-content]');
    if (!template) return;

    quickview.slot.innerHTML = '';
    quickview.slot.appendChild(template.content.cloneNode(true));
    quickview.opener = button;

    /* Das <template> ist beim Rendern auf die damalige Ausführung fixiert —
       hat der Umschalter die Zeile inzwischen gewechselt, den Klon auf die
       aktuelle Variante der Zeile umbiegen. */
    var current = rowVariant(row);
    if (current) {
      var addButton = quickview.slot.querySelector('[data-berndorf-quickview-add]');
      if (addButton) addButton.setAttribute('data-variant-id', current.id);
      var subtitle = quickview.slot.querySelector('[data-berndorf-quickview-subtitle]');
      if (subtitle) subtitle.textContent = current.display_title || current.title;
      setRowLinks(quickview.slot, current);
    }

    root.hidden = false;
    document.documentElement.classList.add('berndorf-quickview-open');
    quickview.dialog.focus();
  }

  function closeQuickview() {
    if (!quickview.root || quickview.root.hidden) return;

    quickview.root.hidden = true;
    quickview.slot.innerHTML = '';
    document.documentElement.classList.remove('berndorf-quickview-open');

    if (quickview.opener) {
      quickview.opener.focus();
      quickview.opener = null;
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-berndorf-quickview-open]');
    if (opener) {
      openQuickview(opener);
      return;
    }

    if (event.target.closest('[data-berndorf-quickview-close]')) {
      closeQuickview();
      return;
    }

    /* Klick neben den Dialog schliesst. Das Ziel ist die Huelle selbst — ein
       eigenes Backdrop-Element gibt es nicht, siehe CSS. */
    if (event.target.hasAttribute('data-berndorf-quickview')) {
      closeQuickview();
      return;
    }

    var add = event.target.closest('[data-berndorf-quickview-add]');
    if (!add) return;

    var scope = add.closest('.berndorf-quickview__body') || document;
    var input = scope.querySelector('[data-berndorf-stepper-input]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    add.disabled = true;
    addItems([{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: quantity }])
      .then(function () {
        closeQuickview();
        return refreshCartCount();
      })
      .catch(function (error) {
        var target = scope.querySelector('.berndorf-quickview__feedback');
        if (!target) {
          target = document.createElement('p');
          target.className = 'berndorf-quickview__feedback';
          add.parentNode.appendChild(target);
        }
        announce(target, error.message || strings.error, true);
      })
      .then(function () {
        add.disabled = false;
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQuickview();
  });

  /* ------------------------------------------------- Ausführung folgt oben
     Der Umschalter der Kaufbox (berndorf-product.js) meldet die gewählte
     Ausführung; jede Zeile mit Varianten wechselt auf ihre passende Variante
     mit. Teile ohne diese Ausführung bleiben, wo sie sind — die erste
     verfügbare Variante ist besser als eine leere Zeile. */

  function rowVariantList(row) {
    if (row._berndorfVariants !== undefined) return row._berndorfVariants;
    var block = row.querySelector('[data-berndorf-row-variants]');
    if (!block) {
      row._berndorfVariants = null;
      return null;
    }
    try {
      row._berndorfVariants = JSON.parse(block.textContent);
    } catch (error) {
      row._berndorfVariants = null;
    }
    return row._berndorfVariants;
  }

  function rowVariant(row) {
    var list = rowVariantList(row);
    if (!list) return null;
    var input = row.querySelector('input[name$="[id]"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    return (
      list.find(function (v) { return v.id === id; }) || null
    );
  }

  /* Ohne `?variant=` öffnet Shopify die erste Variante des Teils — bei Swing
     ist das CR, auch wenn die Zeile Nicro zeigt. Die Links folgen darum der
     Ausführung der Zeile. */
  function setRowLinks(scope, variant) {
    if (!variant.url) return;
    scope.querySelectorAll('[data-berndorf-row-link]').forEach(function (link) {
      link.setAttribute('href', variant.url);
    });
  }

  // Preis einer Nachkauf-Zeile neu aufbauen — mit durchgestrichenem
  // Originalpreis, wenn die Ausführung eine Aktion hat (Markup wie im Liquid).
  function renderRowPrice(el, variant) {
    var onSale = !!variant.compare;
    el.classList.toggle('berndorf-nachkauf__price--on-sale', onSale);
    el.textContent = '';
    function add(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      node.textContent = text;
      el.appendChild(node);
    }
    if (onSale) {
      add('span', 'visually-hidden', el.dataset.labelRegular || '');
      add('s', 'berndorf-nachkauf__price-compare', variant.compare);
      add('span', 'visually-hidden', el.dataset.labelSale || '');
    }
    add('span', '', variant.price);
  }

  document.addEventListener('berndorf:ausfuehrung', function (event) {
    var title = event.detail && event.detail.title;
    if (!title) return;
    var pieceOnly = !!event.detail.pieceOnly;

    document.querySelectorAll('[data-berndorf-nachkauf-row]').forEach(function (row) {
      var list = rowVariantList(row);
      var variant = list && list.find(function (v) { return v.title === title; });

      /* Eine Ausführung, die nur Einzelteile haben: Zeilen ohne sie fallen
         weg statt in einer anderen Ausführung stehen zu bleiben — sonst
         landete beim Klick auf „CR" ein Nicro-Teilset im Warenkorb. */
      row.classList.toggle('is-finish-hidden', pieceOnly && !variant);
      if (pieceOnly && !variant) {
        var hiddenQty = row.querySelector('[data-berndorf-stepper-input]');
        if (hiddenQty && hiddenQty.value !== '0') {
          hiddenQty.value = 0;
          hiddenQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (!variant) return;

      var idInput = row.querySelector('input[name$="[id]"]');
      if (idInput) idInput.value = variant.id;

      setRowLinks(row, variant);

      var price = row.querySelector('[data-berndorf-row-price]');
      if (price) renderRowPrice(price, variant);

      var img = row.querySelector('[data-berndorf-row-img]');
      if (img && variant.img) {
        img.src = variant.img;
        img.removeAttribute('srcset');
      }

      row.classList.toggle('is-variant-unavailable', !variant.available);
      var qty = row.querySelector('[data-berndorf-stepper-input]');
      if (qty && !variant.available) {
        qty.value = 0;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
